import ConfirmPopin from '@scripts/components/ConfirmPopin';
const { _x } = wp.i18n;

/**
 * Admin controller
 */
export default class {
  /**
   * Confirmation popin
   *
   * @private
   *
   * @type {ConfirmPopin}
   */
  #confirmPopin;

  /**
   * @param {HTMLElement} container
   */
  constructor() {
    this.#confirmPopin = new ConfirmPopin(
      _x('Confirm', 'admin button', 'cvrisk-calc'),
      _x('Cancel', 'admin button', 'cvrisk-calc')
    );
  }

  /**
   * Reset country configurations after confirmation
   *
   * @private
   *
   * @param {Event} e Click event
   *
   * @return {void}
   */
  #handlerResetClick(e) {
    e.preventDefault();

    const link = e.currentTarget;
    link.disabled = true;

    this.#confirmPopin
      .confirm(
        _x(
          'Are you sure you want to reset the country configurations?',
          'admin',
          'cvrisk-calc'
        )
      )
      .then((confirm) => {
        if (confirm) {
          document.location = link.href;
        }
      })
      .finally(() => (link.disabled = false));
  }

  /**
   * Delete a country configuration after confirmation
   *
   * @param {Event} e Click event
   *
   * @return {void}
   */
  #handlerDeleteClick(e) {
    e.preventDefault();

    const elt = e.currentTarget;
    elt.disabled = true;

    this.#confirmPopin
      .confirm(
        _x(
          'Are you sure you want to delete this configuration?',
          'admin',
          'cvrisk-calc'
        )
      )
      .then((confirm) => {
        if (confirm) {
          elt.closest('form').submit();
        }
      })
      .finally(() => (elt.disabled = false));
  }

  boot() {
    // delete a country configuration
    document
      .querySelectorAll('.cvrisk-country-configs .cvrisk-btn-delete')
      .forEach((elt) =>
        elt.addEventListener('click', (e) => this.#handlerDeleteClick(e))
      );

    // reset country configurations
    document
      .querySelectorAll('.cvrisk-btn-reset-config')
      .forEach((link) =>
        link.addEventListener('click', (e) => this.#handlerResetClick(e))
      );
  }
}
